import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Employees from './components/Recordings';
import Recordings from './components/Recordings';

const recordings = (props,{ t }) => (
  <Container>
    <Recordings {...props} />
  </Container>
);

recordings.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(recordings);
